import { Button, ButtonGroup, Text, VStack } from '@chakra-ui/react';
import { GoalsListProps } from '@web-app/components/GoalsList/types';
import { FC } from 'react';
import { FiChevronRight } from 'react-icons/fi';

import GoalEditor from '../GoalEditor';

const GoalsList: FC<GoalsListProps> = ({ notes, setNotes }) => {
  const { selectedClientGoalsAndInterventions: goals } = notes;

  if (notes.isGoalsAndInterventionsEditorOpen) {
    return <GoalEditor notes={notes} setNotes={setNotes} />;
  }

  return (
    <>
      {goals.length === 0 && (
        <VStack alignItems={'center'} spacing={4} marginTop="48px">
          <Text>You haven&apos;t set any goals and interventions yet.</Text>
          <Button
            onClick={() =>
              setNotes({ isGoalsAndInterventionsEditorOpen: true })
            }
          >
            Add a goal
          </Button>
        </VStack>
      )}
      {goals.length > 0 && (
        <>
          <VStack
            height={'100%'}
            justifyContent={'space-between'}
            alignItems={'flex-start'}
            className="amp-mask excluded-phi"
          >
            <ButtonGroup
              variant="outline"
              maxW="100%"
              width="100%"
              fontFamily="Plus Jakarta Sans"
            >
              <VStack
                alignItems={'flex-start'}
                maxW="100%"
                width="100%"
                spacing={4}
                flexGrow={1}
                height="100%"
              >
                {goals.map((goal, index) => {
                  return (
                    <Button
                      key={index}
                      padding="18px"
                      alignItems="flex-start"
                      width="100%"
                      whiteSpace={'normal'}
                      color={'green.400'}
                      borderColor={'green.400'}
                      maxHeight="124px"
                      height="auto"
                      rightIcon={<FiChevronRight size="32px" />}
                      _hover={{
                        bg: 'surface.light',
                        color: 'text.brand',
                        borderColor: 'border.brand',
                      }}
                      onClick={() =>
                        setNotes({
                          isGoalsAndInterventionsEditorOpen: true,
                          currentlySelectedGoalIndex: index,
                        })
                      }
                    >
                      <VStack
                        width="100%"
                        alignItems={'flex-start'}
                        justifyContent={'flex-start'}
                        textAlign={'left'}
                        textOverflow={'ellipsis'}
                      >
                        <Text color={'text.brand'} noOfLines={1}>
                          {goal.clientGoalsAndIntentions || 'No goal specified'}
                        </Text>
                        <Text
                          color={'green.400'}
                          fontWeight={500}
                          noOfLines={3}
                        >
                          {goal.actionableIntervention}
                        </Text>
                      </VStack>
                    </Button>
                  );
                })}
              </VStack>
            </ButtonGroup>
            <Button
              alignSelf={'flex-end'}
              onClick={() =>
                setNotes({ isGoalsAndInterventionsEditorOpen: true })
              }
              color="text.brand"
              background="surface.light"
              fontWeight={500}
              borderColor="border.brand"
              borderWidth="2px"
              borderRadius="8px"
              width="110px"
              _hover={{ color: 'white', backgroundColor: 'text.brand' }}
            >
              Add a goal
            </Button>
          </VStack>
        </>
      )}
    </>
  );
};

export default GoalsList;
